import { AidKitLogo } from '@aidkitorg/component-library';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { usePost, useToken } from '../API';

const AIDKIT_LOGO = <AidKitLogo width={100} height={50} />

const ThemeContext = createContext({
  logo: AIDKIT_LOGO
});

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    // TODO: should we throw an error here or just silently fail?
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

type ThemeProviderProps = {
  children: React.ReactNode
}  

type ThemeContextType = {
  logo: React.ReactElement
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [logo, setLogo] = useState<React.ReactElement>(AIDKIT_LOGO)
  const [, token] = useToken();

  const getAuthAwareConfig = usePost("/program/public_configuration");


  useEffect(() => {
    (async () => {
      const publicConfig = await getAuthAwareConfig({})
      if (publicConfig.interface?.applicantFacingLogo?.url) {
        const customLogo = <img
          className="w-auto max-w-[150px] max-h-[125px]"
          src={publicConfig.interface?.applicantFacingLogo?.url}
          alt={publicConfig.name || 'AidKit Program'}
          width={publicConfig.interface?.applicantFacingLogo?.width || '150'}
        />
        setLogo(customLogo)
      }
    })()
  }, [token])
	
  const value: ThemeContextType = {
    logo
  }

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}